/// <amd-module name="Traceability/RunView/Changes/RunViewChangesService" />
import { Change, IArtifactDetails, IDataResult } from "Traceability/Changes/Types";
import { Utilities } from "Traceability/Common/Utilities";
import { IRunViewChangesService } from "Traceability/RunView/Changes/RunViewChangesService.types";
import { RunViewCommonService } from "Traceability/RunView/Common/RunViewCommonService";
import { IVssPageContext, Services } from "VSS/Platform/Context";

export class RunViewChangesService extends RunViewCommonService<Change> implements IRunViewChangesService {
    protected get dataProviderId(): string {
        return this._runDataProviderId;
    }

    public get hubRouteId(): string {
        return this._hubRouteId;
    }

    public getChanges = (artifactDetails: IArtifactDetails): Promise<IDataResult<Change>> => {
        return Utilities.getDataProviderDataAsync<IDataResult<Change>>(this.contributionService, this._dataProviderId, artifactDetails);
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
    }

    public _serviceEnd(pageContext: IVssPageContext): void {
        super._serviceEnd(pageContext);
    }

    private _runDataProviderId = "ms.vss-traceability-web.traceability-run-changes-data-provider";
    private _hubRouteId = "ms.vss-traceability-web.traceability-run-changes-hub-default-route";
    private _dataProviderId = "ms.vss-traceability-web.traceability-changes-data-provider";

}

Services.add("IRunViewChangesService", { serviceFactory: RunViewChangesService });